<template>
  <b-modal id="disabled-race-modal" title="Change Crawl Status" centered>
    <p class="text-black">
      You need to disable crawling before making any changes
    </p>
    <template #modal-footer>
      <div class="d-flex justify-content-end align-items-center">
        <b-button variant="secondary" class="mr-1" @click="closeModal"
          >Cancel</b-button
        >
        <b-button variant="primary" @click="onSubmit">Confirm </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { BModal, BButton } from "bootstrap-vue";
import { mapActions } from "vuex";
export default {
  components: {
    BModal,
    BButton,
  },
  methods: {
    ...mapActions("trading/racing", ["updateRaceDetail"]),
    async onSubmit() {
      const raceId = this.$route.query.raceId;
      if (!raceId) return;
      const result = await this.updateRaceDetail({
        raceId,
        isDisableSync: true,
      });
      if (result) {
        this.closeModal();
        this.$emit("onAfterConfirm");
      }
    },
    closeModal() {
      this.$bvModal.hide("disabled-race-modal");
    },
  },
};
</script>